import { log } from '../../../../utils/Logger'
import EndStage from './EndStage'
import SpeedStage from './SpeedStage'
import StopStage from './StopStage'
import TimeStage from './TimeStage'

export  function  getStage(data, index) {

  switch (data.type) {
    case 'speed': return new SpeedStage(data, index)
    case 'time': return new TimeStage(data, index)
    case 'stop': return new StopStage(data, index)
    case 'end': return new EndStage(data, index)
    default:log('error Factory Stage', 'WARNING')
  }

}
